module.exports = __webpack_public_path__ + "img/logo.ffb94ffd.svg";